import { container } from 'inversify.config';
import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IdentityService } from 'services/identity-service';
import { RequestStatus } from 'stores/requests/requests-store';
import { MultipleSelectionDropdownOptions } from 'widgets/editors/multiple-selection-dropdown';
import TailwindMultiSelect from 'widgets/editors/tailwind-multiselect';

interface MultipleRequestStatusEditorProps {
  value: RequestStatus[];
  onChange?: (value: RequestStatus[]) => void;
  placeholder?: string;
  clearable?: boolean;
  className?: string;
  disabled?: boolean;
  statusFilterActive?: boolean;
  onBlur?: (event: any) => void;
  onFocus?: (event: any) => void;
}

const TailwindMultipleRequestStatusEditor: React.FC<MultipleRequestStatusEditorProps> = ({
  value,
  onChange,
  placeholder,
  clearable = true,
  disabled = false,
  className,
  statusFilterActive,
  onBlur,
  onFocus
}) => {
  const { t } = useTranslation();
  const identityService: IdentityService = container.get(IdentityService);
  const currentUserInfo = identityService.getUserInfo();
  const getAllRequestStatus = () => {
    let map: { id: string; text: string; value: string }[] = [];

    for (let n in RequestStatus) {
      if (typeof RequestStatus[n] === 'number') {
        if (statusFilterActive) {
          if (IdentityService.isPlanner(currentUserInfo)) {
            if (RequestStatus[n].toString() === '20') {
              map.push({ id: RequestStatus[n], text: n, value: RequestStatus[n] });
            }
          } else {
            if (RequestStatus[n].toString() === '10' || RequestStatus[n].toString() === '20' || RequestStatus[n].toString() === '30') {
              map.push({ id: RequestStatus[n], text: n, value: RequestStatus[n] });
            }
          }
        }
        if (!statusFilterActive && (RequestStatus[n].toString() === '40' || RequestStatus[n].toString() === '50')) {
          map.push({ id: RequestStatus[n], text: n, value: RequestStatus[n] });
        }
      }
    }

    return map.sort((a, b) => {
      if (a.text.toLowerCase() < b.text.toLowerCase()) return -1;
      if (a.text.toLowerCase() > b.text.toLowerCase()) return 1;
      return 0;
    });
  };

  const handleOnSelection = (newValue: MultipleSelectionDropdownOptions[]) => {
    const eventInstructorRole: RequestStatus[] = newValue.map(x => RequestStatus[x.id]);
    onChange(eventInstructorRole);
  };

  const [options] = useState<MultipleSelectionDropdownOptions[]>(getAllRequestStatus());

  return (
    <TailwindMultiSelect
      options={options.map(status => ({
        id: status.id,
        text: status.text
      }))}
      value={(value || []).map(x => ({
        id: RequestStatus[x],
        text: x
      }))}
      onChange={handleOnSelection}
      placeholder={placeholder || t('Select requests status')}
      clearable={clearable}
      disabled={disabled}
      className={className}
      onBlur={onBlur}
      onFocus={onFocus}
      searchable
    />
  );
};

// Wire up the React component to the Redux store
export default TailwindMultipleRequestStatusEditor;
